// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"error-page_wrapper__1Symt","title":"error-page_title__P8Gwn"};